module.exports = __webpack_public_path__ + "img/sv37.f0f9b9a1.svg";